import api from "../../../config/axios";
import { logger } from "../../../utils/logger";

export interface FranjaPrecio {
  desde: number;
  hasta: number | null;
  precio: number;
}

export interface DepartamentoCategoria {
  nombre: string;
  capacidad: number;
  departamentos: string[];
  precioCorto: number;
  precioLargo: number;
  /** Precio de cada franja de noches en la tarifa de hoy, si hay tarifa cargada. */
  franjas?: FranjaPrecio[];
  precios_individuales?: {
    [departamento: string]: {
      precioCorto: number;
      precioLargo: number;
      franjas?: FranjaPrecio[];
    };
  };
}

/** Precio por noche de una estadía nueva de `noches` noches. */
export const precioPorNocheDeCategoria = (
  categoria: DepartamentoCategoria,
  noches: number
): number => {
  const franja = categoria.franjas?.find(
    (f) => noches >= f.desde && (f.hasta === null || noches <= f.hasta)
  );
  if (franja) return franja.precio;
  return noches > 15 ? categoria.precioLargo : categoria.precioCorto;
};

// Función para obtener la categoría de un departamento
export const obtenerCategoriaDepartamento = async (
  departamento: string
): Promise<DepartamentoCategoria | undefined> => {
  try {
    const response = await api.get<DepartamentoCategoria[]>(
      "/departamentos/categorias"
    );
    const categorias = response.data;
    const categoria = categorias.find((cat) =>
      cat.departamentos.includes(departamento)
    );

    if (categoria) {
      // Si hay precios individuales para este departamento, usarlos
      const preciosIndividuales =
        categoria.precios_individuales?.[departamento];
      if (preciosIndividuales) {
        const resultado = {
          ...categoria,
          precioCorto: preciosIndividuales.precioCorto,
          precioLargo: preciosIndividuales.precioLargo,
          franjas: preciosIndividuales.franjas,
        };

        return resultado;
      }
    }

    return categoria;
  } catch (error) {
    logger.error("Error al obtener categorías:", error);
    return undefined;
  }
};
